/* 🤖 this file was generated by svg-to-ts */
export const matIconWebAsset: {
  name: 'web-asset';
  data: string;
} = {
  name: 'web-asset',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6a2 2 0 0 0-2-2zm0 14H5V8h14v10z"/></svg>`
};
